import {
  SelectionManagerProvider,
  useSelectionManager,
} from "@prismicio/editor-fields"
import { Box } from "@prismicio/editor-ui"
import { type ReactNode } from "react"

import { BulkActionsProvider } from "../BulkActions/BulkActionsProvider"
import {
  isStandardTaskRecord,
  type TaskRecord,
} from "../BulkActions/bulkActionsService"

interface DocumentListBodyLayoutProps {
  children: ReactNode
}

export function DocumentListBodyLayout(props: DocumentListBodyLayoutProps) {
  const { children } = props

  return (
    <Box
      flexDirection="column"
      gap={24}
      padding={{ left: 24, top: 24, bottom: 24 }}
      width="100%"
    >
      <SelectionManagerProvider>
        <BulkActionsProviderWithSelectionCleanup>
          {children}
        </BulkActionsProviderWithSelectionCleanup>
      </SelectionManagerProvider>
    </Box>
  )
}

interface BulkActionsProviderWithSelectionCleanupProps {
  children: ReactNode
}

function BulkActionsProviderWithSelectionCleanup(
  props: BulkActionsProviderWithSelectionCleanupProps,
) {
  const { children } = props

  const selectionManager = useSelectionManager()

  function onCompletion(task: TaskRecord) {
    // we have to check that the item is indeed a task document to be able to
    // get the document id the bulk action was run against, since we are
    // storing documentIds in our selection manager
    // Failed items can either be a task document or task locale

    const failedDocumentIds = task.failed.flatMap((error) => {
      return isStandardTaskRecord(error) ? error.documentId : []
    })

    task.items.forEach(
      (item) =>
        isStandardTaskRecord(item) &&
        !failedDocumentIds.includes(item.documentId) &&
        selectionManager.toggleSelection({ id: item.documentId }),
    )
  }

  return (
    <BulkActionsProvider onCompletion={onCompletion}>
      {children}
    </BulkActionsProvider>
  )
}
